(function () {
  var bar = document.querySelector('[data-cm-catbar]');
  if (!bar || bar.dataset.ready) return;
  bar.dataset.ready = '1';

  var root = document.documentElement;
  var current = 'all';
  var scheduled = false;

  function setCount() {
    var n = current === 'all'
      ? document.querySelectorAll('.product-grid__item').length
      : document.querySelectorAll('.product-grid__item[data-cm-cats~="' + current + '"]').length;
    var text = n + (n > 1 ? ' articles' : ' article');
    document.querySelectorAll('.products-count-wrapper [role="status"]').forEach(function (el) {
      if (el.textContent.trim() !== text) el.textContent = text;
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; setCount(); }, 60);
  }

  function select(cat, push) {
    current = cat;
    if (cat === 'all') root.removeAttribute('data-cm-cat'); else root.setAttribute('data-cm-cat', cat);
    bar.querySelectorAll('.cm-catbar__item').forEach(function (b) {
      var on = b.dataset.cat === cat;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (push) {
      try { history.replaceState(null, '', location.pathname + location.search + (cat === 'all' ? '' : '#' + cat)); } catch (e) {}
    }
    setCount();
  }

  bar.addEventListener('click', function (e) {
    var b = e.target.closest('.cm-catbar__item');
    if (b) select(b.dataset.cat, true);
  });

  new MutationObserver(function (records) {
    if (current === 'all') return;
    var relevant = records.some(function (r) {
      var t = r.target;
      return t && t.closest && !t.closest('.products-count-wrapper') && !t.closest('[data-cm-catbar]');
    });
    if (relevant) schedule();
  }).observe(document.body, { childList: true, subtree: true });

  var hash = (location.hash || '').replace('#', '');
  if (hash && bar.querySelector('[data-cat="' + hash + '"]')) select(hash, false);
})();